import * as Sentry from '@sentry/react'
import { router } from './router.tsx'

Sentry.init({
	dsn: 'https://c11f86095ef7fdb601a56079f0abfb3d@o4509955767336960.ingest.de.sentry.io/4509955785949264',
	environment: import.meta.env.MODE,
	integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
	tracesSampler: ({ inheritOrSampleWith, name }) => {
		if (name.includes('/_public/auth')) return 1
		return inheritOrSampleWith(0.1)
	},
})
